import { authedJson } from '../api/client';

export type TaskStatus = 'TODO' | 'IN_PROGRESS' | 'DONE' | 'BLOCKED';

export interface Task {
  taskId: string;
  workspaceId: string;
  projectId: string;
  epicId: string;
  sprintId: string | null;
  title: string;
  description: string;
  status: string;
  points: number;
  labelIds: string[];
  assigneeIds: string[];
  complexity: number | null;
  startDate: string | null;
  endDate: string | null;
  completedAt: number | null;
  createdBy: string;
  createdAt: number;
  updatedAt: number;
}

export interface UpdateTaskRequest {
  title?: string;
  description?: string;
  status?: string;
  projectId?: string;
  /** Use the literal "NONE" to unassign the task from any sprint. */
  sprintId?: string;
  points?: number;
  labelIds?: string[];
  assigneeIds?: string[];
  complexity?: number;
  startDate?: string;
  endDate?: string;
}

type GetToken = () => string | null;
type DoRefresh = () => Promise<boolean>;

export const tasksApi = {
  list: (workspaceId: string, projectId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<{ tasks: Task[] }>(
      `/workspaces/${workspaceId}/projects/${projectId}/tasks`,
      { method: 'GET' },
      getToken,
      doRefresh,
    ),

  create: (
    workspaceId: string,
    projectId: string,
    fields: {
      title: string;
      description?: string;
      points?: number;
      assigneeIds?: string[];
      labelIds?: string[];
      complexity?: number;
      startDate?: string;
      endDate?: string;
    },
    getToken: GetToken,
    doRefresh: DoRefresh,
  ) =>
    authedJson<Task>(
      `/workspaces/${workspaceId}/projects/${projectId}/tasks`,
      { method: 'POST', body: JSON.stringify(fields) },
      getToken,
      doRefresh,
    ),

  get: (workspaceId: string, taskId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<Task>(`/workspaces/${workspaceId}/tasks/${taskId}`, { method: 'GET' }, getToken, doRefresh),

  update: (
    workspaceId: string,
    taskId: string,
    updates: UpdateTaskRequest,
    getToken: GetToken,
    doRefresh: DoRefresh,
  ) =>
    authedJson<Task>(
      `/workspaces/${workspaceId}/tasks/${taskId}`,
      { method: 'PUT', body: JSON.stringify(updates) },
      getToken,
      doRefresh,
    ),

  remove: (workspaceId: string, taskId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<void>(`/workspaces/${workspaceId}/tasks/${taskId}`, { method: 'DELETE' }, getToken, doRefresh),

  listForSprint: (workspaceId: string, sprintId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<{ tasks: Task[] }>(
      `/workspaces/${workspaceId}/sprints/${sprintId}/tasks`,
      { method: 'GET' },
      getToken,
      doRefresh,
    ),
};
